import React from "react";

/* Theme  : same as Our Values.
   Colours: text #4e5356 | buttons #2596be | headings #4573a6 | line #c9dde8
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body)
   Icons  : brand colour on a light tile; on hover the tile fills with the brand
            colour and the icon turns white, so it is always visible. */

interface Site {
  label: string;
  url: string;
  icon: React.ReactNode;
  color: string;
}

const sites: Site[] = [
  {
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/106907834/",
    color: "#0077B5",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61578474913924",
    color: "#1877F2",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/atuminfotech/",
    color: "#E4405F",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.975.975 1.245 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.332 2.633-1.308 3.608-.975.975-2.242 1.245-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.332-3.608-1.308-.975-.975-1.245-2.242-1.308-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.332-2.633 1.308-3.608.975-.975 2.242-1.245 3.608-1.308 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.337 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28 0.073-1.689.073-4.948s-0.014-3.667-0.072-4.947c-0.2-4.337-2.618-6.78-6.98-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-0.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c0.795 0 1.439-0.645 1.439-1.44s-0.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    url: "https://wa.me/+918080411453",
    color: "#25D366",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.438 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
      </svg>
    ),
  },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400&family=Ubuntu:wght@700&display=swap");
.ssb{--text:#4e5356;--head:#4573a6;--btn:#2596be;--line:#c9dde8;--tint:#eef6fa;
  position:fixed;left:0;top:50%;transform:translateY(-50%);z-index:999;
  display:flex;flex-direction:column;align-items:center;gap:10px;padding:14px 10px 14px 8px;
  font-family:"Open Sans",sans-serif;font-weight:400;
  background:rgba(255,255,255,.92);backdrop-filter:blur(12px);
  border:1px solid var(--line);border-left:none;border-radius:0 24px 24px 0;
  box-shadow:0 24px 44px -22px rgba(69,115,166,.65);
  animation:ssbIn .8s cubic-bezier(.2,.8,.2,1) backwards}

/* small handle on top */
.ssb-head{display:flex;flex-direction:column;align-items:center;gap:6px;padding-bottom:10px;margin-bottom:2px;border-bottom:1px solid var(--line);width:100%}
.ssb-head i{width:8px;height:8px;border-radius:50%;background:var(--btn);animation:ssbPulse 2s infinite}
.ssb-head span{writing-mode:vertical-rl;transform:rotate(180deg);font-family:"Ubuntu",sans-serif;font-weight:700;font-size:10px;letter-spacing:2px;text-transform:uppercase;color:var(--head)}

.ssb-item{position:relative;display:block;text-decoration:none}

/* tile: brand colour on light bg; fills with brand colour on hover */
.ssb-tile{--c:var(--btn);width:42px;height:42px;border-radius:14px;display:flex;align-items:center;justify-content:center;
  background:var(--tint);border:1px solid var(--line);color:var(--c);
  transition:background .35s,color .35s,border-color .35s,transform .45s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.ssb-item:hover .ssb-tile{background:var(--c);color:#fff;border-color:transparent;transform:translateX(4px) rotate(-6deg) scale(1.08);
  box-shadow:0 14px 22px -10px var(--c)}

/* label pill slides out to the right, outside the dock */
.ssb-label{position:absolute;left:calc(100% + 14px);top:50%;transform:translate(-10px,-50%);padding:7px 14px;border-radius:50px;
  background:var(--c);color:#fff;font-size:12px;letter-spacing:.8px;text-transform:uppercase;white-space:nowrap;pointer-events:none;opacity:0;
  box-shadow:0 12px 20px -10px var(--c);transition:opacity .3s,transform .4s cubic-bezier(.3,1.4,.5,1)}
.ssb-label::before{content:"";position:absolute;left:-4px;top:50%;width:10px;height:10px;margin-top:-5px;background:var(--c);transform:rotate(45deg);border-radius:2px}
.ssb-item:hover .ssb-label{opacity:1;transform:translate(0,-50%)}

@keyframes ssbIn{from{opacity:0;transform:translate(-50px,-50%)}}
@keyframes ssbPulse{0%{box-shadow:0 0 0 0 rgba(37,150,190,.5)}70%{box-shadow:0 0 0 8px rgba(37,150,190,0)}100%{box-shadow:0 0 0 0 rgba(37,150,190,0)}}

@media(max-width:768px){.ssb{display:none}}
@media(prefers-reduced-motion:reduce){
  .ssb,.ssb *{animation:none!important;transition:none!important}
}
`;

const SiteSidebar: React.FC = () => {
  return (
    <>
      <style>{STYLES}</style>

      <div className="ssb">
        {/* <div className="ssb-head">
          <i />
          <span>Follow</span>
        </div> */}

        {sites.map((site) => (
          <a
            key={site.url}
            href={site.url}
            target="_blank"
            rel="noopener noreferrer"
            className="ssb-item"
            aria-label={site.label}
            style={{ ["--c" as any]: site.color }}
          >
            <div className="ssb-tile">{site.icon}</div>
            <span className="ssb-label">{site.label}</span>
          </a>
        ))}
      </div>
    </>
  );
};

export default SiteSidebar;